'use strict';
module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/shortid/index.js
 ** module id = 190
 ** module chunks = 0
 **/